
import { computed, defineComponent, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from '@/store';
import { killFirestoreListeners, initSyncFirestoreWithVuexStore } from '@/utils';
import TextInput from '@/components/form-controls/base/TextInput.vue';
import ButtonInput from '@/components/form-controls/base/ButtonInput.vue';
import AppNoAuthContainer from '@/components/AppNoAuthContainer.vue';

export default defineComponent({
  name: 'GroupCreateOrJoin',
  components: {
    AppNoAuthContainer,
    TextInput,
    ButtonInput
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const groupName = ref('');
    const joinLink = ref('');

    const createGroup = async (e: Event) => {
      e.preventDefault();
      await store.dispatch.groups.createGroup(groupName.value);
      await initSyncFirestoreWithVuexStore();
      await router.push('/bids');
    };

    const linkId = computed(() => {
      if (!joinLink.value.includes('/')) return joinLink.value;

      const lastSlash = joinLink.value.lastIndexOf('/');
      return joinLink.value.substring(lastSlash + 1);
    });

    const joinGroup = async (e: Event) => {
      e.preventDefault();
      if (store.getters.groups.getGroupId) {
        await router.push('/bids');
      }

      store.dispatch.internal.update(['isLoading', true]);
      const isSuccessful = await store.dispatch.groups.joinWithGroupLink(linkId.value);

      if (!isSuccessful) {
        store.dispatch.internal.update(['isLoading', false]);
        // eslint-disable-next-line no-alert
        window.alert('There was an error joining the group.');
      } else {
        await killFirestoreListeners();
        await initSyncFirestoreWithVuexStore();
        store.dispatch.internal.update(['isLoading', false]);
        await router.push('/bids');
      }
    };

    return {
      createGroup,
      groupName,
      joinLink,
      joinGroup
    };
  }
});
